const buildOtherTestsObject = (tests: string[]) =>
  tests.reduce((acc, t, i) => ({ ...acc, [`t${i + 1}`]: t }), {});

const jackLgvOtherTests = [
  'Testosterone free and total',
  'B12',
  'Estradiol',
  'LH',
  'FSH',
  'TSH',
  'Prolactin',
  'Lipase',
  'CRP',
  'Total Insulin',
  'Magnesium (Serum)',
  'Lipoprotein(a)',
  'Homocysteine',
  'AST',
  'SHBG',
  'Cortisol (random)',
  'Serum iron (Fe)',
  'TIBC',
  '% transferrin saturation',
  'Ferritin',
  'Free T3/Free T4',
  'GGT (Gamma-glutamyl transferase)',
  'Calcium',
  'Serum Phosphate (PO4)',
  'Nucleated RBC (NRBC)'
];

const jillLgvOtherTests = [
  'B12',
  'Serum iron (Fe)',
  'TIBC',
  '% transferrin saturation',
  'Ferritin',
  'TSH',
  'Lipase',
  'CRP',
  'Total Insulin',
  'Progesterone',
  'Estradiol',
  'LH',
  'FSH',
  'Testosterone (Total)',
  'Prolactin',
  'DHEA-S',
  'Free T3/Free T4',
  'Magnesium (Serum)',
  'AST',
  'GGT (Gamma-glutamyl transferase)',
  'Lipoprotein(a)',
  'Cortisol (random)',
  'Calcium',
  'Serum Phosphate (PO4)',
  'Nucleated RBC (NRBC)',
  'Apolipoprotein B (ApoB)'
];

const baseLgvTests = {
  insuranceType_OHIP: true,
  biochemistry_glucose: true,
  biochemistry_glucose_glucose_fasting: true,
  biochemistry_hbA1C: true,
  biochemistry_creatinine: true,
  biochemistry_uricAcid: true,
  biochemistry_sodium: true,
  biochemistry_potassium: true,
  biochemistry_alt: true,
  biochemistry_alk: true,
  biochemistry_albumin: true,
  biochemistry_lipid: true,
  hematology_cbc: true
};

const lgvPaidFields = {
  lgvPaid_danTalya: true,
  lgvPaid_docFee: true,
  lgvPaid_vitaminD25: true,
};

export const ON_LGV_PAID_DEFAULT_VALUE = ({ customer, organization }) => {
  const defaultsByProfile = {
    jack_health: {
      ...baseLgvTests,
      psa_insured: true,
      otherTests_test: buildOtherTestsObject(jackLgvOtherTests),
      ...lgvPaidFields,
      lgvPaid_shbg: true,
      lgvPaid_psa: true,
    },
    jill_health: {
      ...baseLgvTests,
      otherTests_test: buildOtherTestsObject(jillLgvOtherTests),
      ...lgvPaidFields,
      lgvPaid_shbg: false,
      lgvPaid_psa: false,
    }
  };
  const normalizedGender = customer?.gender?.toLowerCase?.();
  if (normalizedGender === 'male' || normalizedGender === 'm') {
    return defaultsByProfile.jack_health;
  }
  if (normalizedGender === 'female' || normalizedGender === 'f') {
    return defaultsByProfile.jill_health;
  }
  return defaultsByProfile[organization] || defaultsByProfile.jack_health;
};
